import Collapse from "bootstrap/js/src/collapse";

export default class MobileMenu {
	/**
	 *
	 * @param {Main} mainInstance
	 */
	constructor(mainInstance) {
		/**
		 * @type {Main}
		 */
		this.main = mainInstance;

		this.$siteHeader = mainInstance.getHeaderController().getElement();
		if (this.$siteHeader) {
			/**
			 * @type {HTMLElement}
			 */
			this.$nav = this.$siteHeader.querySelector("nav.mobile-navigation");

			if (this.$nav !== null) {
				/**
				 * @type {HTMLElement}
				 */
				this.$toggle = this.$nav.querySelector(".hamburger");
				/**
				 * @type {HTMLElement}
				 */
				this.$overlay = document.querySelector("#MobileMenuOverlay");
				/**
				 * @type {HTMLElement}
				 */
				this.$panel = this.$nav.querySelector(".navigation-panel");

				if (this.$toggle) {
					this.$toggle.addEventListener("click", this.onToggle.bind(this));
				}

				if (this.$overlay) {
					this.$overlay.addEventListener("click", this.onToggle.bind(this));
				}

				this.$nav.querySelectorAll(`li[class*="children"]`)
					.forEach(item => {
						const toggle = document.createElement("i");
						const aEl = item.querySelector("a");

						toggle.classList.add("fas", "fa-angle-down");
						aEl.setAttribute("aria-expanded", "false");
						aEl.setAttribute("aria-haspopup", "true");

						item.append(toggle);
						const submenu = toggle.previousElementSibling;
						new Collapse(submenu, {
							toggle: false
						});
						submenu.classList.add("collapse");
						toggle.addEventListener("click", this.onMenuItemClick.bind(this));
					});

				window.addEventListener("load", () => {
					window.setTimeout(() => {
						this.$panel.classList.add("ready");
					}, 1000);
				});
			}
		}


	}

	toggle() {
		if (this.$toggle.classList.contains("active")) {
			this.$toggle.classList.remove("active");
			this.$panel.classList.remove("active");
			this.$overlay.classList.remove("active");
			window.document.body.classList.remove("mobile-nav-active");
		} else {
			this.$toggle.classList.add("active");
			this.$panel.classList.add("active");
			this.$overlay.classList.add("active");
			window.document.body.classList.add("mobile-nav-active");
		}
	}

	adjustPanelOffset() {
		const headerCompStyle = window.getComputedStyle(this.$siteHeader);
		const isHeaderFixed = headerCompStyle.position === "fixed";
		let offset;

		if(!isHeaderFixed) {
			offset = this.$siteHeader.offsetTop + this.$siteHeader.clientHeight - window.scrollY;
		}
		else {
			offset = this.$siteHeader.clientHeight;
		}

		const height = window.innerHeight - this.$siteHeader.clientHeight;
		this.$panel.style.top = `${offset}px`;
		this.$panel.style.height = `${height}px`;
	}

	/**
	 *
	 * @param  {Event} e
	 */
	onMenuItemClick(e) {
		/**
		 * @type {HTMLElement}
		 */
		const $item = e.currentTarget;
		const $childMenu = $item.previousElementSibling;
		const collapse = Collapse.getInstance($childMenu);
		collapse.toggle();
	}

	/**
	 *
	 * @param  {Event} e
	 */
	onToggle(e) {
		e.preventDefault();
		this.adjustPanelOffset();
		this.toggle();
	}
}
